const CHUNK = /(\d+|\D+)/g;

function splitChunks(value) {
  return String(value).toLowerCase().match(CHUNK) || [];
}

function normalize(value) {
  return value == null ? '' : String(value).trim();
}

export function compareClass(a, b) {
  const left = normalize(a);
  const right = normalize(b);

  if (!left && !right) return 0;
  if (!left) return 1;
  if (!right) return -1;

  const l = splitChunks(left);
  const r = splitChunks(right);
  const len = Math.max(l.length, r.length);

  for (let i = 0; i < len; i++) {
    const x = l[i];
    const y = r[i];
    if (x === undefined) return -1;
    if (y === undefined) return 1;

    const xIsNum = /^\d/.test(x);
    const yIsNum = /^\d/.test(y);

    if (xIsNum && yIsNum) {
      const diff = Number(x) - Number(y);
      if (diff) return diff < 0 ? -1 : 1;
    } else if (xIsNum !== yIsNum) {
      return xIsNum ? -1 : 1;
    } else if (x !== y) {
      return x < y ? -1 : 1;
    }
  }

  return 0;
}

export function sortByClass(list, field) {
  return [...list].sort(
    (a, b) => compareClass(a[field], b[field]) || Number(a.class_id) - Number(b.class_id),
  );
}
